import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/layout/App';
import './styles/main.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

try {
    // Web3Modal configuration will throw if environment is invalid
    import('./config/web3modal')
        .then(() => {
            root.render(
                <React.StrictMode>
                    <ToastContainer
                        position="bottom-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="dark"
                    />
                    <App />
                </React.StrictMode>
            );
        })
        .catch(error => {
            root.render(
                <div className="min-h-screen flex items-center justify-center bg-red-50">
                    <div className="max-w-md p-8 bg-white rounded-lg shadow-lg">
                        <h1 className="text-2xl font-bold text-red-600 mb-4">
                            Configuration Error
                        </h1>
                        <div className="bg-red-100 border-l-4 border-red-500 p-4">
                            <p className="font-mono text-sm text-red-700 whitespace-pre-wrap">
                                {error.message}
                            </p>
                        </div>
                    </div>
                </div>
            );
            console.error('Initialization Error:', error);
        });
} catch (error) {
    root.render(
        <div className="min-h-screen flex items-center justify-center bg-red-50">
            <div className="max-w-md p-8 bg-white rounded-lg shadow-lg">
                <h1 className="text-2xl font-bold text-red-600 mb-4">
                    Fatal Error
                </h1>
                <div className="bg-red-100 border-l-4 border-red-500 p-4">
                    <p className="font-mono text-sm text-red-700 whitespace-pre-wrap">
                        {error.message}
                    </p>
                </div>
            </div>
        </div>
    );
    console.error('Fatal Error:', error);
}

reportWebVitals();